import { gql } from 'graphql-request';

export const GET_FUEL_DOCUMENT_SCHEME = gql`
  query App70e9b8a9_Document($documentId: String) {
    app70e9b8a9_Document {
      getTemplate(documentId: $documentId) {
        template {
          step
          name
          type
          value
          required
          isSearchable
          placeholder
          fieldTransform
          fieldType
          label {
            en
            ru
          }
          stepLabel
          validation
          options {
            label
            value
          }
        }
      }
    }
  }
`;
